<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    size="lg"
    no-close-on-backdrop
    hide-footer
    static
    @show="onShow"
  >
    <template #modal-header-close>
      <i class="fa fa-close" />
    </template>
    <b-row>
      <b-col>
        <b-alert
          v-model="showErrors"
          variant="danger"
          dismissible
        >
          <p
            class="mb-0"
            v-for="(error, index) in baseServerErrors"
            :key="index"
          >
            {{ error }}
          </p>
          <p
            class="mb-0"
            v-for="(error, index) in serverErrors"
            :key="index"
          >
            {{ error }}
          </p>
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="selectableType">
      <b-col class="mb-3">
        <label class="text-muted font-w500 font-size-sm mb-1 d-block">
          Photo Type
        </label>
        <b-form-radio-group
          v-model="selectedType"
          :options="typeOptions"
          name="photo-type"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <vue-dropzone
          ref="myVueDropzone"
          :id="`dropzone-${modalId}`"
          :key="dropzoneKey"
          :options="dropzoneOptions"
          @vdropzone-error="handleError"
        />
      </b-col>
    </b-row>

    <hr class="mt-4">

    <b-row>
      <b-col
        offset-lg="6"
        lg="3"
        order="2"
        order-lg="1"
      >
        <b-button
          variant="link-dark"
          block
          class="work-order-new-photo-close-button"
          @click="closeModal()"
        >
          Cancel
        </b-button>
      </b-col>
      <b-col
        lg="3"
        order="1"
        order-lg="2"
      >
        <b-button
          variant="primary"
          block
          class="work-order-new-photo-close-button"
          @click="finishUpload()"
        >
          Save
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from 'axios';
import formMixin from '@/mixins/formMixin';
import { adminPath } from '@/api/helpers/apiPath';
import dropzoneDefaults from '@/utils/dropzoneDefaults';

const PHOTO_TYPES = {
  before: { value: 'before', text: 'Before', path: 'before_photos' },
  after: { value: 'after', text: 'After', path: 'after_photos' },
  no_show: { value: 'no_show', text: 'No Show', path: 'no_show_photos' },
};

export default {
  name: 'WorkOrdersNewPhotoModal',
  mixins: [formMixin],
  props: {
    title: {
      type: String,
      default: 'New Photo',
    },
    modalId: {
      type: String,
      default: 'work-order-new-photo-modal',
    },
    workOrderId: {
      type: Number,
    },
    beforePhoto: {
      type: Boolean,
      default: false,
    },
    afterPhoto: {
      type: Boolean,
      default: false,
    },
    selectableType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showErrors: false,
      customErrorMessage: 'File is too big, maximum image size permitted is 5mb.',
      fieldLabels: {
        before_photos: 'Photo',
        after_photos: 'Photo',
        no_show_photos: 'Photo',
      },
      MAX_FILE_SIZE: 5000,
      selectedType: 'before',
      dropzoneKey: Date.now(),
      typeOptions: [
        { value: 'before', text: 'Before' },
        { value: 'after', text: 'After' },
        { value: 'no_show', text: 'No Show' },
      ],
    };
  },
  watch: {
    selectedType() {
      if (this.selectableType) {
        this.dropzoneKey = Date.now();
      }
    },
  },
  computed: {
    modalTitle() {
      if (this.selectableType) {
        return 'Add Photos';
      }
      return this.title;
    },
    resolvedType() {
      if (this.selectableType) {
        return this.selectedType;
      }
      if (this.beforePhoto) {
        return 'before';
      }
      if (this.afterPhoto) {
        return 'after';
      }
      return 'no_show';
    },
    dropzoneOptions() {
      return {
        ...dropzoneDefaults,
        url: this.uploadUrl,
        headers: { Authorization: this.$store.getters.token },
        dictDefaultMessage: 'Choose photos or drop them here to upload',
        thumbnailWidth: 125,
        thumbnailHeight: 125,
      };
    },
    uploadUrl() {
      const photoPath = PHOTO_TYPES[this.resolvedType].path;
      return `${axios.defaults.baseURL}/${adminPath(`/work_orders/${this.workOrderId}/${photoPath}`)}`;
    },
  },
  methods: {
    onShow() {
      this.selectedType = 'before';
      this.showErrors = false;
      this.dropzoneKey = Date.now();
    },
    closeModal() {
      if (this.$refs.myVueDropzone) {
        this.$refs.myVueDropzone.removeAllFiles(true);
      }
      this.showErrors = false;
      this.$bvModal.hide(this.modalId);
    },
    finishUpload() {
      this.$emit('on-save');
      this.closeModal();
    },
    handleError(_file, error) {
      if (_file.size > this.MAX_FILE_SIZE) {
        _file.previewElement.querySelector('.dz-error-message span').textContent = this.customErrorMessage;
      }
      this.processServerErrors(error?.errors);
      this.showErrors = this.baseServerErrors.length > 0 || Object.keys(this.serverErrors).length > 0;
    },
  },
};
</script>
